import { render, staticRenderFns } from "./DetachNetwork.vue?vue&type=template&id=c30ca3da"
import script from "./DetachNetwork.vue?vue&type=script&lang=js"
export * from "./DetachNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports